import { render, staticRenderFns } from "./couponsProperty.vue?vue&type=template&id=3f18d843&scoped=true"
import script from "./couponsProperty.vue?vue&type=script&lang=js"
export * from "./couponsProperty.vue?vue&type=script&lang=js"
import style0 from "./couponsProperty.vue?vue&type=style&index=0&id=3f18d843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f18d843",
  null
  
)

export default component.exports